var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.val))])])])}
var staticRenderFns = []

export { render, staticRenderFns }